import { render } from "./user-groups.vue?vue&type=template&id=cfc6b13a&ts=true"
import script from "./user-groups.vue?vue&type=script&lang=ts"
export * from "./user-groups.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__